<template lang="pug">
    .generic-wrapper
      .container
        .card.margin-top
          .main
            b-table(:data="ownerSettlements"
                    default-sort-direction="desc"
                    default-sort="createdAt"
                    hoverable)
              b-table-column(label='Empfänger' sortable, v-slot="props")
                div(v-if="props.row.owner.fullName")
                  a(@click="$router.push({ name: 'DataOwnerEdit', params: { id: props.row.ownerId } })")
                    b-icon(icon="account")
                    | {{' ' + props.row.owner.fullName}}
              b-table-column(field='name' label='Anhang' sortable, v-slot="props")
                a(v-if="props.row.name" @click="openPDF(props.row)") Anhang.pdf
              b-table-column(label='Monat' sortable, v-slot="props")
                | {{new Date(props.row.year, props.row.month, 1).toLocaleDateString('de-DE' ,  {month: 'short', year: 'numeric'})}}
              b-table-column(field='totalSettlement' numeric label='Abrechnungsbetrag' sortable, v-slot="props")
                | {{props.row.totalSettlement/100 | toCurrency}}
              b-table-column(field='createdAt' label='erstellt am' sortable, v-slot="props")
                | {{formatDate(props.row.createdAt)}}
              b-table-column(label='Aktionen', v-slot="props")
                .button-wrapper(v-if="props.row.errorContractCount > 0")
                  b-button(type="is-danger" @click="deleteOwnerSetllement(props.row)") Defekt Löschen
    </template>
    
    <script>
    import { DateTime } from 'luxon';
    
    export default {
      data() {
        return {
        };
      },
      computed: {
        ownerSettlements() {
          return this.$store.state.ownerSettlements.all;
        },
      },
      methods: {
        async openPDF(ownerSettlement) {
          let newFile = await this.$store.dispatch('ownerSettlements/getAttachementPdf', {id: ownerSettlement.id});
          const file = new Blob([newFile], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        },
        deleteOwnerSetllement(row) {
          this.$buefy.dialog.confirm({
            title: "Abrechnung löschen",
            message: `Sind Sie sicher, dass Sie diese Abrechnung <b>${row.name}</b> löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
            confirmText: "Abrechnung löschen",
            cancelText: "Abbrechen",
            type: "is-danger",
            hasIcon: true,
            onConfirm: async () => {
              try {
                await this.$store.dispatch("ownerSettlements/delete", { id: row.id });
                this.$buefy.toast.open("Abrechnung gelöscht!");
              } catch (e) {
                this.$store.dispatch(
                  "common/showError",
                  "Abrechnung konnte nicht gelöscht werden."
                );
              }
            }
          });
        },
        formatDate(d) {
          const dt = DateTime.fromISO(d);
          return dt.setLocale('de')
            .toFormat("dd. LLL. yyyy hh:mm")
        },
      },
      mounted() {
        this.$store.dispatch("ownerSettlements/findAll");
      }
    };
    </script>
    
    <style lang="scss" scoped>
    .icon-name {
      margin-left: $sm-space;
    }
    </style>